import { useEffect, useState } from 'react';
import { getEnv } from 'util/getEnv';

export const useTestError = name => {
  const [error, setError] = useState(null);
  if (error) throw error;

  useEffect(() => {
    /* istanbul ignore else */
    if (getEnv('NODE_ENV') === 'test') {
      window.testError = {
        ...window.testError,
        [name]: setError,
      };
    }
  }, [name]);
};
